/**
 * ModificationModal — request modifications on a store activation request.
 * Extracted from ManagePlatform.js
 */
import { Edit3, Loader2 } from 'lucide-react';
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';

export default function ModificationModal({
  open,
  onOpenChange,
  selectedStore,
  storeEditReasons,
  selectedModificationReason,
  setSelectedModificationReason,
  modificationMessage,
  setModificationMessage,
  onCancel,
  onConfirm,
  processingStore,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#1a1a2e] border-[#2a2a4e] text-white"
        data-testid="modification-modal"
      >
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <Edit3 className="h-5 w-5 text-blue-500" />
            طلب تعديل على المتجر
          </DialogTitle>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <p className="text-[#808080]">
            سيتم إرسال طلب تعديل للمتجر: <span className="text-white font-medium">{selectedStore?.name}</span>
          </p>

          <div>
            <label className="text-sm text-[#808080] mb-2 block">سبب طلب التعديل *</label>
            <select
              value={selectedModificationReason}
              onChange={(e) => setSelectedModificationReason(e.target.value)}
              className="w-full p-3 bg-[#0a0a0a] border border-[#2a2a4e] rounded-xl text-white focus:border-blue-500 outline-none"
              data-testid="modification-reason-select"
            >
              <option value="">اختر سبب التعديل</option>
              {storeEditReasons.map((reason) => (
                <option key={reason.id} value={reason.label_ar}>
                  {reason.label_ar}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-sm text-[#808080] mb-2 block">ملاحظات إضافية</label>
            <textarea
              value={modificationMessage}
              onChange={(e) => setModificationMessage(e.target.value)}
              placeholder="أضف ملاحظات إضافية للتاجر (اختياري)..."
              className="w-full h-24 bg-[#0a0a0a] border border-[#2a2a4e] rounded-xl p-3 text-white placeholder:text-[#606060] resize-none focus:border-blue-500 focus:outline-none"
              data-testid="modification-notes"
            />
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            className="border-[#2a2a4e] text-white"
            data-testid="modification-cancel-btn"
          >
            إلغاء
          </Button>
          <Button
            onClick={onConfirm}
            disabled={!selectedModificationReason || processingStore === selectedStore?.id}
            className="bg-blue-600 hover:bg-blue-700 text-white"
            data-testid="modification-confirm-btn"
          >
            {processingStore === selectedStore?.id ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <>
                <Edit3 className="h-4 w-4 me-2" />
                إرسال طلب التعديل
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
